import React from "react";
import {LocalReducerEventProps, LocalReducerState} from "./reducer.types";
import {GetFilmIdResultType} from "../../../../../models/google_search";

const SET_RESULTS = 'SET_RESULTS';

export const dispatchToProps = (dispatch: React.Dispatch<any>): LocalReducerEventProps => ({
    setProcessResult: (results: GetFilmIdResultType) => {
        dispatch({
            type: SET_RESULTS,
            results,
        })
    }
});

export const initState: LocalReducerState = {
    processResult: {},
};

export const component_reducer = (state: LocalReducerState = initState, action: any) => {
    switch (action.type) {
        case SET_RESULTS: {
            return {...state,
                processResult: action.results
            };
        }
        default:
            return state;
    }
};
